import { Check } from 'lucide-react';

export type ToastTone = 'success' | 'error' | 'warning' | 'info';

/**
 * The one status mark every toast in the app carries, whichever library raised
 * it: a 16px tinted circle with its glyph, as Linear draws it. The card stays
 * white; colour lives only here.
 */
export function ToastIcon({ tone }: { tone: ToastTone }) {
  return (
    <span className="mb-toast-icon" data-tone={tone} aria-hidden>
      {tone === 'success' ? <Check strokeWidth={3} /> : tone === 'info' ? 'i' : '!'}
    </span>
  );
}

/** Sonner's `icons` prop: our marks for every status, its own spinner for loading. */
export const SONNER_TOAST_ICONS = {
  success: <ToastIcon tone="success" />,
  error: <ToastIcon tone="error" />,
  warning: <ToastIcon tone="warning" />,
  info: <ToastIcon tone="info" />,
};
